export default __webpack_public_path__ + "static/18692-2e1df1d3f86b589e9d348db871b8dd08.jpg";